import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import { DeleteFaqRequest } from '@/types/request/DeleteFaqRequest';

const useFaqDelete = () => {
  const client = supabaseClient;

  const mutationFn = async (request: DeleteFaqRequest) => {
    return deleteFaq(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['faq'] });
    },
  });
};

export default useFaqDelete;

async function deleteFaq(client: SupabaseClient, request: DeleteFaqRequest): Promise<void> {
  const { error } = await client.from('questions').delete().in('id', request.ids);

  if (error) throw new Error(error.message);

  return;
}
